import React, { useEffect, useState } from "react";
import AdminLTE, {
  Sidebar,
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
  Label,
  SimpleTable,
  Pagination,
} from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import controllerAusencias from "../ausencias/duck";
import { useSelector, useDispatch } from "react-redux";
import { responseSelector } from "../utils/helpers/selectors";
import { logger, thousandSeparator } from "../utils/utils";
import moment from "moment";
import config from "../config";
import queryString from "query-string";

const { Select2, Date, DateTime, Text } = Inputs;

function Local({ history, match }) {
  const dispatch = useDispatch();
  const [servicioFiltro, setServicioFiltro] = useState(null);
  const [profesionalFiltro, setProfesionalFiltro] = useState(null);

  const modelAmbientes = useSelector((state) => state.ambientesByLocal);
  const modelProfesionales = useSelector((state) => state.profesionalesByLocal);
  const modelLocal = useSelector((state) => state.localById);
  const modelServiciosPadre = useSelector((state) => state.serviciosPadre);

  const modelHorarios = useSelector((state) => state.horariosByLocal);
  const modelEliminarHorario = useSelector((state) => state.eliminarHorario);

  const modelAusencias = useSelector((state) => state.getAusencias);
  const modelDeleteAusencia = useSelector((state) => state.deleteAusencia);

  const [ausencias, setAusencias] = useState([]);
  const [totalResultsAusencias, setTotalResultsAusencias] = useState(0);
  const [activePageAusencias, setActivePageAusencias] = useState(0);
  const [pageSizeAusencias, setPageSizeAusencias] = useState(10);

  const [profesionales, setProfesionales] = useState(null);
  const [totalResultsProf, setTotalResultsProf] = useState(0);
  const [activePageProf, setActivePageProf] = useState(0);
  const [pageSizeProf, setPageSizeProf] = useState(5);

  const [ambientes, setAmbientes] = useState(null);
  const [totalResultsAmbientes, setTotalResultsAmbientes] = useState(0);
  const [activePageAmbientes, setActivePageAmbientes] = useState(0);
  const [pageSizeAmbientes, setPageSizeAmbientes] = useState(5);

  const [local, setLocal] = useState(null);

  const [serviciosPadre, setServiciosPadre] = useState(null);
  const [totalResultsServPadre, setTotalResultsServPadre] = useState(0);
  const [activePageServPadre, setActivePageServPadre] = useState(0);
  const [pageSizeServPadre, setPageSizeServPadre] = useState(5);

  const [horarios, setHorarios] = useState(null);
  const [totalResultsHorarios, setTotalResultsHorarios] = useState(0);
  const [activePageHorarios, setActivePageHorarios] = useState(0);
  const [pageSizeHorarios, setPageSizeHorarios] = useState(5);

  const modelEliminacionImgLocal = useSelector((state) => {
    return state.eliminacionImgLocal;
  });

  useEffect(() => {
    // TODO usar "selectors" para data y error

    const data = modelEliminacionImgLocal?.data?.data?.data;
    const error = modelEliminacionImgLocal?.error;
    const errorMessage =
      modelEliminacionImgLocal?.error?.response?.data?.mensaje;

    if (error) {
      if (errorMessage) {
        alert(errorMessage);
      }
      // setImagenesListaLoading(false);
      dispatch(controller.duckLocalById.actions.clear());
    }

    if (data) {
      dispatch(controller.localByIdThunk(match.params.id));
    }
  }, [modelEliminacionImgLocal, dispatch]);

  useEffect(() => {
    const data = modelDeleteAusencia?.data?.data;
    const error = modelDeleteAusencia?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controllerAusencias.deleteAusenciaDuck.actions.clear());
    }
    if (data) {
      handlePageAusencias(0);
      dispatch(controllerAusencias.deleteAusenciaDuck.actions.clear());
    }
  }, [modelDeleteAusencia]);

  useEffect(() => {
    const { data, error } = responseSelector(modelAusencias);

    if (error) {
      alert(error);
      dispatch(controllerAusencias.duck.actions.clear());
    }
    if (data) {
      setAusencias(data.items);
      setTotalResultsAusencias(data.total);

      dispatch(controllerAusencias.duck.actions.clear());
    }
  }, [modelAusencias]);

  useEffect(() => {
    const data = modelEliminarHorario?.data?.data;
    const error = modelEliminarHorario?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckEliminarHorario.actions.clear());
    }
    if (data) {
      handlePageHorarios(0);
      dispatch(controller.duckEliminarHorario.actions.clear());
    }
  }, [modelEliminarHorario]);

  useEffect(() => {
    const data = modelHorarios?.data?.data;
    const error = modelHorarios?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckHorariosByLocal.actions.clear());
    }
    if (data) {
      setHorarios(data.data.items);
      setTotalResultsHorarios(data.data.total);

      dispatch(controller.duckHorariosByLocal.actions.clear());
    }
  }, [modelHorarios]);

  useEffect(() => {
    const data = modelProfesionales?.data?.data;
    const error = modelProfesionales?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckProfesionalesByLocal.actions.clear());
    }
    if (data) {
      setProfesionales(data.data.items);
      setTotalResultsProf(data.data.total);

      dispatch(controller.duckProfesionalesByLocal.actions.clear());
    }
  }, [modelProfesionales]);

  useEffect(() => {
    const data = modelAmbientes?.data?.data;
    const error = modelAmbientes?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckAmbientesByLocal.actions.clear());
    }
    if (data) {
      setAmbientes(data.data.items);
      setTotalResultsAmbientes(data.data.total);

      dispatch(controller.duckAmbientesByLocal.actions.clear());
    }
  }, [modelAmbientes]);

  useEffect(() => {
    const data = modelServiciosPadre?.data?.data;
    const error = modelServiciosPadre?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckServiciosPadre.actions.clear());
    }
    if (data) {
      setServiciosPadre(data.data.items);
      setTotalResultsServPadre(data.data.total);

      dispatch(controller.duckServiciosPadre.actions.clear());
    }
  }, [modelServiciosPadre]);

  useEffect(() => {
    const data = modelLocal?.data?.data;
    const error = modelLocal?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckLocalById.actions.clear());
    }
    if (data) {
      setLocal(data.data);

      dispatch(controller.duckLocalById.actions.clear());
    }
  }, [modelLocal]);

  useEffect(() => {
    dispatch(
      controller.profesionalesByLocalThunk(match.params.id, 1, pageSizeProf)
    );
    dispatch(
      controller.getAmbientesByLocalThunk(match.params.id, 1, pageSizeAmbientes)
    );
    dispatch(
      controller.serviciosPadreThunk(match.params.id, 1, pageSizeServPadre)
    );

    dispatch(
      controller.horariosByLocalThunk(
        match.params.id,
        1,
        pageSizeHorarios,
        profesionalFiltro,
        servicioFiltro
      )
    );

    dispatch(controller.localByIdThunk(match.params.id));

    dispatch(
      controllerAusencias.getAusenciasThunk(
        match.params.id,
        1,
        pageSizeAusencias
      )
    );
  }, []);

  const doEliminarImagen = (imagenID) => {
    const localId = match.params.id;
    const token = localStorage.getItem("token");
    // setImagenesListaLoading(true);

    let data = {
      imagenID,
      localId: localId,
      token,
    };
    dispatch(controller.eliminarImgLocalThunk(data));
  };

  function handlePageAusencias(page) {
    setActivePageAusencias(page);
    setAusencias([]);
    dispatch(
      controllerAusencias.getAusenciasThunk(
        match.params.id,
        page + 1,
        pageSizeAusencias
      )
    );
  }

  function handlePageAmbientes(page) {
    setActivePageAmbientes(page);
    setAmbientes([]);
    dispatch(
      controller.getAmbientesByLocalThunk(
        match.params.id,
        page + 1,
        pageSizeAmbientes
      )
    );
  }

  function handlePage(page) {
    setActivePageProf(page);
    setProfesionales([]);
    dispatch(
      controller.profesionalesByLocalThunk(
        match.params.id,
        page + 1,
        pageSizeProf
      )
    );
  }

  function handlePageServPadre(page) {
    setActivePageServPadre(page);
    setServiciosPadre([]);
    dispatch(
      controller.serviciosPadreThunk(
        match.params.id,
        page + 1,
        pageSizeServPadre
      )
    );
  }

  function handlePageHorarios(page) {
    setActivePageHorarios(page);
    setHorarios([]);
    dispatch(
      controller.horariosByLocalThunk(
        match.params.id,
        page + 1,
        pageSizeHorarios,
        profesionalFiltro,
        servicioFiltro
      )
    );
  }

  function eliminarHorario(data) {
    let datos = {
      _id: data._id,
      id: data._id,
      dia: data.numeroDia,
      duracion: data.duracion,
      inicio: data.inicio,
      fin: data.fin,
      servicioId: data.foreingKey,
      profesionalId: data.extraKey.profesionalId,
      localId: data.localId,
    };

    dispatch(controller.eliminarHorarioThunk(datos));
  }

  const navegarASubirImagen = () => {
    logger.debug("navigateToSubirImagenes");

    const token = localStorage.getItem("token");

    const baseUrl = config.api.baseUrl;
    const key = config.api.key;

    const localId = match.params.id;

    const concepto = "local";
    const conceptoId = localId;

    logger.debug({ concepto });
    logger.debug({ config });
    logger.debug({
      imgRestrictionsByConcepto: config.imgRestrictionsByConcepto[concepto],
    });

    const uploadConfigVariant = "upload";
    const cropConfigVariant = "crop";

    const uploadUrl = `${baseUrl}/agregarImagen/${concepto}/${conceptoId}/?userToken=${token}&esTemporal=true&configVariant=${uploadConfigVariant}`;
    const uploadHeaders = {
      "x-access-token": key,
    };

    const cropUploadUrl = `${baseUrl}/agregarImagen/${concepto}/${conceptoId}/?userToken=${token}&esTemporal=false&configVariant=${cropConfigVariant}`;
    const cropConfig =
      config.imgRestrictionsByConcepto[concepto][cropConfigVariant];

    const nextStepUrl = `/cortarImagenes`;
    const lastStepUrl = `/local/${localId}`;

    const params = queryString.stringify({
      conceptoId,
      concepto,
      uploadUrl,
      rawUploadHeaders: JSON.stringify(uploadHeaders),
      nextStepUrl,
      pageTitle: "Subida de imágenes",
      pageSubtitle: "Paso 1 : Subida",
      nextButtonText: "Siguiente",
      cropConfig: JSON.stringify(cropConfig),
      cropUploadUrl,
      saveInConceptUrl: `${baseUrl}/agregarImagenALocal`,
      lastStepUrl,
      ...config.imgRestrictionsByConcepto[concepto][uploadConfigVariant],
    });

    logger.debug("EditServicioHijo.paramsBeforeNavigate");
    logger.debug(params);

    history.push(`/subirImagenes?${params}`);
  };

  return (
    <Content title="Local" subTitle="Local" browserTitle="Local" show={false}>
      <Row>
        <Col md="4">
          <Box title="Detalles del local">
            {local ? (
              <React.Fragment>
                <p style={{ fontSize: 16 }}>
                  <strong>Nombre: </strong>
                  {local.nombre}
                </p>

                {/* <p style={{ fontSize: 16 }}>
                  <strong>Pago habilitado: </strong>
                  {local.metodoPago === 20
                    ? "Si"
                    : local.pagoApp === 30
                    ? "Opcional"
                    : "No"}
                </p> */}
                <p style={{ fontSize: 16 }}>
                  <strong>Ciudad: </strong>
                  {local.direccion.ciudad}
                </p>
                <p style={{ fontSize: 16 }}>
                  <strong>Direccion: </strong>
                  {local.direccion.calle}
                </p>
                {/* <p style={{ fontSize: 16 }}>
                  <strong>Estado: </strong>
                  {local.estado}
                </p> */}
                {local.categoriaId === "60f7f0a397887a90e7bfed2b" ? (
                  <>
                    <Button
                      block={true}
                      type="primary"
                      text="Lista de planes"
                      onClick={() => history.push(`/planes/${match.params.id}`)}
                    />
                    <Button
                      block={true}
                      type="primary"
                      text="Lista de usuarios"
                      onClick={() =>
                        history.push(`/usuariosList/${match.params.id}`)
                      }
                    />
                  </>
                ) : null}

                {local?.imagenes &&
                Array.isArray(local.imagenes) &&
                local.imagenes.length ? (
                  <div>
                    <hr />
                    <h4>Imagen</h4>
                  </div>
                ) : null}

                {local?.imagenes &&
                Array.isArray(local.imagenes) &&
                local.imagenes.length
                  ? local.imagenes.map((imagenObj, index) => {
                      return (
                        <div>
                          <div style={{ marginBottom: 20 }}>
                            <p>
                              <b>Nombre de archivo:</b>
                              <br />
                              {imagenObj.url.split("/").pop()}
                            </p>
                            <a href={imagenObj.url}>Ver imagen</a>
                          </div>
                          <Button
                            type="primary"
                            text="Eliminar"
                            pullRight={true}
                            onClick={() => doEliminarImagen(imagenObj._id)}
                          />
                        </div>
                      );
                    })
                  : null}

                <Button
                  pullRight={true}
                  type="primary"
                  text="Subir imagen"
                  onClick={navegarASubirImagen}
                />
              </React.Fragment>
            ) : (
              <h4>Cargando...</h4>
            )}
          </Box>
        </Col>
        {local && local.categoriaId === "60f806a5e3e9af972fe85c7a" ? (
          <Col md="8">
            <Box title="Ambientes">
              <Button
                type="primary"
                text="Agregar"
                pullRight={true}
                onClick={() =>
                  history.push(`/nuevoAmbiente/${match.params.id}`)
                }
              />
              <div>
                <span>Total: {totalResultsAmbientes}</span>
              </div>
              {ambientes && ambientes.length > 0 ? (
                <SimpleTable
                  hover={true}
                  data={ambientes.map((row, index) => {
                    return {
                      nombre: row.nombre,
                      estado: row.estado,
                      maxPersonas: row.maxPersonas,
                      editar: (
                        <Button
                          type="primary"
                          text="Editar"
                          onClick={() =>
                            history.push(`/editAmbiente/${row._id}`)
                          }
                        />
                      ),
                    };
                  })}
                  columns={[
                    { title: "Nombre", data: "nombre" },
                    { title: "Estado", data: "estado" },
                    { title: "Maximo de personas", data: "maxPersonas" },
                    { title: "Editar", data: "editar" },
                  ]}
                />
              ) : (
                <h4>No se han encontrado ambientes</h4>
              )}
              <Pagination
                activePage={activePageAmbientes}
                pageSize={pageSizeAmbientes}
                totalElements={totalResultsAmbientes}
                onChange={handlePageAmbientes}
                labels={{
                  first: "Primera",
                  last: "Última",
                  previous: "Anterior",
                  next: "Siguiente",
                }}
              />
              <div>
                <span>Total: {totalResultsAmbientes}</span>
              </div>
            </Box>
          </Col>
        ) : (
          <Col md="8">
            <Box title="Profesionales">
              <Button
                type="primary"
                text="Agregar"
                pullRight={true}
                onClick={() =>
                  history.push(`/nuevoProfesional/${match.params.id}`)
                }
              />
              <div>
                <span>Total: {totalResultsProf}</span>
              </div>
              {profesionales && profesionales.length > 0 ? (
                <SimpleTable
                  hover={true}
                  data={profesionales.map((row, index) => {
                    return {
                      nombre: row.nombre,
                      estado: row.estado,
                      editar: (
                        <Button
                          type="primary"
                          text="Editar"
                          onClick={() =>
                            history.push(`/editProfesional/${row._id}`)
                          }
                        />
                      ),
                    };
                  })}
                  columns={[
                    { title: "Nombre", data: "nombre" },
                    { title: "Estado", data: "estado" },
                    { title: "Editar", data: "editar" },
                  ]}
                />
              ) : (
                <h4>No se han encontrado profesionales</h4>
              )}
              <Pagination
                activePage={activePageProf}
                pageSize={pageSizeProf}
                totalElements={totalResultsProf}
                onChange={handlePage}
                labels={{
                  first: "Primera",
                  last: "Última",
                  previous: "Anterior",
                  next: "Siguiente",
                }}
              />
              <div>
                <span>Total: {totalResultsProf}</span>
              </div>
            </Box>
          </Col>
        )}

        <Col md="12">
          <Box title="Lista de ausencias">
            <Col md="8"></Col>
            <Col md="12">
              <div style={{ marginTop: 15 }}>
                <Button
                  type="primary"
                  text="Agregar"
                  pullRight={true}
                  onClick={() =>
                    history.push(`/addAusencia/${match.params.id}`)
                  }
                />
                <div>
                  <span>Total: {totalResultsAusencias}</span>
                </div>
              </div>
            </Col>
            {ausencias && ausencias.length > 0 ? (
              <SimpleTable
                hover={true}
                data={ausencias.map((row, index) => {
                  return {
                    profesional: row.profesionalNombre,
                    fecha: moment(row.fecha, "YYYY-MM-DD").format("YYYY-MM-DD"),
                    inicio: row.horaInicio,
                    fin: row.horaFin,
                    eliminar: (
                      <Button
                        type="danger"
                        text="Eliminar"
                        onClick={() =>
                          dispatch(
                            controllerAusencias.deleteAusenciaThunk({
                              id: row._id,
                            })
                          )
                        }
                      />
                    ),
                  };
                })}
                columns={[
                  { title: "Profesional", data: "profesional" },
                  { title: "Fecha", data: "fecha" },
                  { title: "Inicio", data: "inicio" },
                  { title: "Fin", data: "fin" },
                  { title: "Accion", data: "eliminar" },
                ]}
              />
            ) : (
              <Col md="12">
                <h4>No se han encontrado resutlados</h4>
              </Col>
            )}
            <Pagination
              activePage={activePageAusencias}
              pageSize={pageSizeAusencias}
              totalElements={totalResultsAusencias}
              onChange={handlePageAusencias}
              labels={{
                first: "Primera",
                last: "Última",
                previous: "Anterior",
                next: "Siguiente",
              }}
            />
            <div>
              <span>Total: {totalResultsAusencias}</span>
            </div>
          </Box>
        </Col>

        <Col md="12">
          <Box title="Servicios Padres">
            <Button
              type="primary"
              text="Agregar"
              pullRight={true}
              onClick={() =>
                history.push(`/nuevoServicioPadre/${match.params.id}`)
              }
            />
            <div>
              <span>Total: {totalResultsServPadre}</span>
            </div>
            {serviciosPadre && serviciosPadre.length > 0 ? (
              <SimpleTable
                hover={true}
                data={serviciosPadre.map((row, index) => {
                  return {
                    nombre: (
                      <a
                        onClick={() =>
                          history.push(
                            `/serviciosHijosList/${match.params.id}/${row._id}/${local.categoriaId}`
                          )
                        }
                      >
                        {row.nombre}
                      </a>
                    ),
                    estado: row.estado,
                  };
                })}
                columns={[
                  { title: "Nombre", data: "nombre" },
                  { title: "Estado", data: "estado" },
                ]}
              />
            ) : (
              <h4>No se han encontrado servicios</h4>
            )}
            <Pagination
              activePage={activePageServPadre}
              pageSize={pageSizeServPadre}
              totalElements={totalResultsServPadre}
              onChange={handlePageServPadre}
              labels={{
                first: "Primera",
                last: "Última",
                previous: "Anterior",
                next: "Siguiente",
              }}
            />
            <div>
              <span>Total: {totalResultsServPadre}</span>
            </div>
          </Box>
        </Col>
        {local && local.categoriaId !== "60f806a5e3e9af972fe85c7a" ? (
          <Col md="12">
            <Box title="Horarios">
              <Col md="8">
                <Col md="3">
                  <Text
                    labelPosition="above"
                    size="sm"
                    label="Profesional"
                    value={profesionalFiltro}
                    onChange={(evt) => setProfesionalFiltro(evt.target.value)}
                  />
                </Col>
                <Col md="3">
                  <Text
                    labelPosition="above"
                    size="sm"
                    label="Servicio"
                    value={servicioFiltro}
                    onChange={(evt) => setServicioFiltro(evt.target.value)}
                  />
                </Col>
                <Col md="3">
                  <div style={{ marginTop: 15 }}>
                    <Button
                      type="primary"
                      text="Filtrar"
                      onClick={() => handlePageHorarios(0)}
                    />
                  </div>
                </Col>
              </Col>

              <Col md="12">
                <div style={{ marginTop: 15 }}>
                  <Button
                    type="primary"
                    text="Agregar"
                    pullRight={true}
                    onClick={() =>
                      history.push(`/nuevoHorario/${match.params.id}`)
                    }
                  />
                  <div>
                    <span>Total: {totalResultsHorarios}</span>
                  </div>
                </div>
              </Col>
              {horarios && horarios.length > 0 ? (
                <SimpleTable
                  hover={true}
                  data={horarios.map((row, index) => {
                    return {
                      dia: row.dia,
                      inicio: row.inicio,
                      fin: row.fin,
                      servicio: row.servicioNombre,
                      profesional: row.profesionalNombre,
                      editar: (
                        <Button
                          type="primary"
                          text="Editar"
                          onClick={() =>
                            history.push(`/editarHorario/${row._id}`)
                          }
                        />
                      ),
                      eliminar: (
                        <Button
                          type="danger"
                          text="Eliminar"
                          onClick={() => eliminarHorario(row)}
                        />
                      ),
                    };
                  })}
                  columns={[
                    { title: "Dia", data: "dia" },
                    { title: "Inicio", data: "inicio" },
                    { title: "Fin", data: "fin" },
                    { title: "Servicio", data: "servicio" },
                    { title: "Profesional", data: "profesional" },
                    { title: "Editar", data: "editar" },
                    { title: "Eliminar", data: "eliminar" },
                  ]}
                />
              ) : (
                <Col md="12">
                  <h4>No se han encontrado horarios</h4>
                </Col>
              )}
              <Pagination
                activePage={activePageHorarios}
                pageSize={pageSizeHorarios}
                totalElements={totalResultsHorarios}
                onChange={handlePageHorarios}
                labels={{
                  first: "Primera",
                  last: "Última",
                  previous: "Anterior",
                  next: "Siguiente",
                }}
              />
              <div>
                <span>Total: {totalResultsHorarios}</span>
              </div>
            </Box>
          </Col>
        ) : null}
      </Row>
    </Content>
  );
}

export default Local;
